import React from 'react';

const Footer = () => {
    return (
        <div className='text-center pb-2'>
            <small>All rights reserved || <a className='text-blue-500 font-bold' href="https://www.rakibulhasandev.com/">Rakibul Hasan</a></small>
        </div>
    );
};

export default Footer;